module.exports = __webpack_public_path__ + "static/image-medium-eaf01498da19e8fafe37890211ecac9d.jpg";